import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function TropipuntosSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-[#0d2b28] py-24 lg:py-32">
      <div className="mx-auto max-w-3xl px-6 text-center">

        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-[#F5E9C9] text-[#B07D10] text-sm font-semibold px-5 py-2 rounded-full mb-8">
          <svg className="w-4 h-4 fill-[#D9A520]" viewBox="0 0 20 20">
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
          {t('tropipuntos.badge')}
        </div>

        {/* Title */}
        <h2 className="text-4xl lg:text-5xl font-brave-hunter text-white leading-tight mb-6">
          {t('tropipuntos.title')}
        </h2>

        {/* Description */}
        <p className="text-base lg:text-lg text-gray-300 mb-12 leading-relaxed max-w-2xl mx-auto">
          {t('tropipuntos.description')}
        </p>

        {/* CTA Button */}
        <Link
          to="/register"
          className="inline-block bg-white text-[#187672] font-semibold text-base px-10 py-4 rounded-full hover:bg-gray-100 transition-colors"
        >
          {t('tropipuntos.cta')}
        </Link>

      </div>
    </section>
  );
}
